import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const adminSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.admin;
  }
);
